"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.regexp.to-string.js");

var _InputNumber = _interopRequireDefault(require("@/components/common/InputNumber"));

var _vuex = require("vuex");

var _index = require("@/model/exchange/index");

var _settings = require("@/model/settings");

var _bignumber = _interopRequireDefault(require("bignumber.js"));

var _message = require("@/components/dialog/message");

var _SocketDispatcher = _interopRequireDefault(require("@/assets/js/SocketDispatcher"));

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  components: {
    InputNumber: _InputNumber.default
  },
  mixins: [_commonMixin.default],
  props: {
    assetsInfoList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    marketList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    assetsInfo: {
      type: Object,
      default: function _default() {
        return {
          remain: {
            all_u_valuation: {
              usdt: "--"
            },
            list: []
          }
        };
      }
    },
    swap_symbol_id: {
      type: Number,
      default: function _default() {
        22;
      }
    },
    from_symbol: {
      type: [String, Number]
    },
    to_symbol: {
      type: [String, Number]
    },
    from_item_id: {
      type: [String, Number]
    },
    to_item_id: {
      type: [String, Number]
    }
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    language: "user/language",
    userInfo: "user/userInfo"
  })), {}, {
    apiAssetsRemain: function apiAssetsRemain() {
      var _this = this;

      var tempObj = 0;

      if (JSON.stringify(this.apiAssetsInfo) != "{}" && this.apiAssetsInfo.remain.list.length > 0) {
        this.apiAssetsInfo.remain.list.forEach(function (ele) {
          if (ele.item_id == _this.to_item_id) {
            tempObj = ele.over;
          }
        });
      } else {
        tempObj = 0;
      }

      return tempObj;
    },
    assetsInfoWs: function assetsInfoWs() {
      var _this2 = this;

      var tempObj = 0;

      if (JSON.stringify(this.assetsInfo) != "{}" && this.assetsInfo.remain.list.length > 0) {
        this.assetsInfo.remain.list.forEach(function (ele) {
          if (ele.item_id == _this2.to_item_id) {
            tempObj = ele.over;
          }
        });
      } else {
        tempObj = 0;
      }

      return tempObj;
    },
    apiAssetsRemainSell: function apiAssetsRemainSell() {
      var _this3 = this;

      var tempObj = 0;

      if (JSON.stringify(this.apiAssetsInfo) != "{}" && this.apiAssetsInfo.remain.list.length > 0) {
        this.apiAssetsInfo.remain.list.forEach(function (ele) {
          if (ele.item_id == _this3.from_item_id) {
            tempObj = ele.over;
          }
        });
      } else {
        tempObj = 0;
      }

      return tempObj;
    },
    assetsInfoWsSell: function assetsInfoWsSell() {
      var _this4 = this;

      var tempObj = 0;

      if (JSON.stringify(this.assetsInfo) != "{}" && this.assetsInfo.remain.list.length > 0) {
        this.assetsInfo.remain.list.forEach(function (ele) {
          if (ele.item_id == _this4.from_item_id) {
            tempObj = ele.over;
          }
        });
      } else {
        tempObj = 0;
      }

      return tempObj;
    },
    // 现有U资产
    assetsInfoShow: function assetsInfoShow() {
      if (this.apiAssetsBtn) {
        return this.apiAssetsRemain;
      } else {
        return this.assetsInfoWs;
      }
    },
    // 现有币资产
    assetsInfoShowSell: function assetsInfoShowSell() {
      if (this.apiAssetsBtn) {
        return this.apiAssetsRemainSell;
      } else {
        return this.assetsInfoWsSell;
      }
    },
    // 市场现在交易价格
    marketInfoShow: function marketInfoShow() {
      var _this5 = this;

      var marketInfo = {
        last: "",
        currency: {
          cny: ""
        }
      };
      this.marketList.forEach(function (ele) {
        if (ele.symbol_id == _this5.swap_symbol_id) {
          marketInfo = ele;
        }
      });
      return marketInfo;
    },
    // 买入交易量
    tradingVolume: function tradingVolume() {
      var tempVal = "0";

      if (this.buyAmount == "0") {
        tempVal = "0";
      } else if (this.buyAmount != "" && this.marketInfoShow.last) {
        var bigBuyAmount = new _bignumber.default(this.buyAmount);
        var bigMarketInfoShow = new _bignumber.default(JSON.parse(JSON.stringify(this.marketPrice)));
        tempVal = bigBuyAmount.div(bigMarketInfoShow).toNumber().toFixed(this.number_precision);
      } else {
        tempVal = "0";
      }

      return tempVal;
    },
    // 买入交易额
    transactionAmount: function transactionAmount() {
      var tempVal = "0";

      if (this.currChainValue == "1") {
        if (this.buyNum == "0") {
          tempVal = "0";
        } else if (this.buyNum != "" && this.marketInfoShow.last) {
          var bigBuyNum = new _bignumber.default(this.buyNum);
          var bigMarketInfoShow = new _bignumber.default(this.marketInfoShow.last);
          tempVal = bigBuyNum.times(bigMarketInfoShow).toNumber().toFixed(this.price_precision);
        } else {
          tempVal = "0";
        }
      } else if (this.currChainValue == "2") {
        if (this.buyNum == "0") {
          tempVal = "0";
        } else if (this.buyNum != "" && this.buyPrice) {
          var _bigBuyNum = new _bignumber.default(this.buyNum);

          var _bigMarketInfoShow = new _bignumber.default(this.buyPrice);

          var tempValV2 = _bigBuyNum.times(_bigMarketInfoShow).toNumber();

          tempVal = this.ceilNumber(tempValV2, this.price_precision);
        } else {
          tempVal = "0";
        }
      }

      return tempVal;
    }
  }),
  watch: {
    swap_symbol_id: function swap_symbol_id() {
      this.buySliderValue = 0;
      this.buyNum = "";
      this.buyPrice = "";
      this.buyAmount = "";
      this.sellSliderValue = 0;
      this.sellPrice = "";
      this.sellNum = "";
      this.number_precision = this.coinInfoMap[this.swap_symbol_id].number_precision;
      this.price_precision = this.coinInfoMap[this.swap_symbol_id].price_precision;
    }
  },
  data: function data() {
    return {
      coinInfoMap: {},
      apiAssetsInfo: {},
      currChainValue: "1",
      sellTransactionAmountSelf: "",
      sellTransactionAmount: "",
      buyTransactionAmount: "",
      buyTransactionAmountSelf: "",
      buySliderValue: 0,
      sellSliderValue: 0,
      marketPrice: "",
      buyPrice: "",
      sellPrice: "",
      buyNum: "",
      buyAmount: "",
      //
      sellNum: "",
      buyTriggerPrice: "",
      sellTriggerPrice: "",
      number_precision: "",
      price_precision: "",
      // from_item_id: "",
      // to_item_id: "",
      marks: {
        25: "25%",
        50: "50%",
        75: "75%"
      },
      coinInfoList: [],
      tabsOptions: [{
        label: "市价",
        value: 1
      }, {
        label: "限价",
        value: 2
      } // {
      //   label: "止盈止损",
      // },
      ],
      inputControl: false,
      buyBtnLoading: false,
      sellBtnLoading: false,
      apiAssetsBtn: false
    };
  },
  created: function created() {
    var _this6 = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this6.getStaticTableInfo(55);

            case 2:
              _context.next = 4;
              return _this6.getAssets();

            case 4:
              _SocketDispatcher.default.addEventListener("onPriceClick", _this6.onPriceClick, _this6);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    routeSplicing: _routeSplicing.default,
    getAssets: function getAssets() {
      var _this7 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, _yield$apiGetAssets, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this7.userInfo) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                params = {
                  type: "all"
                };
                _context2.next = 5;
                return (0, _index.apiGetAssets)(params);

              case 5:
                _yield$apiGetAssets = _context2.sent;
                status = _yield$apiGetAssets.status;
                data = _yield$apiGetAssets.data;

                if (status == 200) {
                  _this7.apiAssetsBtn = true;
                  _this7.apiAssetsInfo = data;
                  setTimeout(function () {
                    _this7.apiAssetsBtn = false;
                  }, 15000);
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onPriceClick: function onPriceClick(row) {
      if (this.currChainValue == "2") {
        this.buyPrice = row[0];
        this.onBuyNumChange();
        this.sellPrice = row[0];
        this.onSellPriceChange();
      }
    },
    // 买入滑块变化
    onBuySliderChange: function onBuySliderChange(value) {
      this.marketPrice = JSON.parse(JSON.stringify(this.marketInfoShow.last));

      if (this.currChainValue == "1") {
        if (value && !this.inputControl) {
          // 买入交易额
          this.buyAmount = (value / 100 * this.assetsInfoShow).toFixed(this.price_precision);
          this.buyTransactionAmount = (value / 100 * this.assetsInfoShow / this.marketPrice).toFixed(this.number_precision);
        } else if (value == 0 && !this.inputControl) {
          this.buyAmount = "";
          this.buyTransactionAmount = "";
        }
      } else if (this.currChainValue == "2") {
        if (this.buyPrice && !this.inputControl) {
          this.buyTransactionAmountSelf = (value / 100 * this.assetsInfoShow).toFixed(this.price_precision);
          this.buyNum = (value / 100 * this.assetsInfoShow / this.buyPrice).toFixed(this.number_precision);
        }

        if (value == 0 && !this.inputControl) {
          this.buyNum = "";
          this.buyTransactionAmountSelf = "";
        }
      }
    },
    // 卖出滑块变化
    onSellSliderChange: function onSellSliderChange(value) {
      this.marketPrice = JSON.parse(JSON.stringify(this.marketInfoShow.last));
      var tempMarketPrice = new _bignumber.default(this.marketPrice);

      if (value == 0) {
        this.sellNum = "";
        this.sellTransactionAmount = "";
        this.sellTransactionAmountSelf = "";
        return;
      }

      if (this.currChainValue == "1") {
        if (value && !this.inputControl) {
          if (value == 100) {
            this.sellNum = this.assetsInfoShowSell.toString().substring(0, this.assetsInfoShowSell.toString().indexOf(".") + this.number_precision + 1);
          } else {
            this.sellNum = (value * 0.01 * this.assetsInfoShowSell).toFixed(this.number_precision);
          }

          if (Number(this.sellNum) > Number(this.assetsInfoShowSell)) {
            this.sellNum = this.assetsInfoShowSell;
          }

          var tempSellNum = new _bignumber.default(this.sellNum);
          var tempValue3 = tempSellNum.times(tempMarketPrice).toNumber();

          if (tempValue3.toString().indexOf(".") > 0) {
            this.sellTransactionAmount = tempValue3.toString().substring(0, tempValue3.toString().indexOf(".") + this.price_precision + 1);
          } else {
            this.sellTransactionAmount = tempValue3;
          }
        } else if (value == 0 && !this.inputControl) {
          this.sellNum = "";
          this.sellTransactionAmount = "";
        }
      } else if (this.currChainValue == "2") {
        if (!this.inputControl) {
          if (value == 100) {
            this.sellNum = this.assetsInfoShowSell.toString().substring(0, this.assetsInfoShowSell.toString().indexOf(".") + this.number_precision + 1);
          } else {
            this.sellNum = (value / 100 * this.assetsInfoShowSell).toFixed(this.number_precision);
          }

          if (Number(this.sellNum) > Number(this.assetsInfoShowSell)) {
            this.sellNum = this.assetsInfoShowSell;
          }

          var _tempSellNum = new _bignumber.default(this.sellNum);

          var tempSellPrice = new _bignumber.default(this.sellPrice);

          var _tempValue = _tempSellNum.times(tempSellPrice);

          if (this.sellPrice) {
            if (_tempValue.toFixed(this.price_precision).indexOf(".") > 0) {
              this.sellTransactionAmountSelf = _tempValue.toFixed(this.price_precision).substring(0, _tempValue.toString().indexOf(".") + this.price_precision + 1);
            } else {
              this.sellTransactionAmountSelf = _tempValue.toFixed(this.price_precision);
            }
          }
        } else {// this.sellNum = "";
          // this.sellTransactionAmountSelf = "";
        }
      }
    },
    // 市价交易额变化
    onBuyAmountChange: function onBuyAmountChange(val) {
      var _this8 = this;

      this.marketPrice = JSON.parse(JSON.stringify(this.marketInfoShow.last));
      this.inputControl = true;
      var tempInput = new _bignumber.default(val);
      var tempAssetsInfoShow = new _bignumber.default(this.assetsInfoShow);
      var tempVal = tempInput.div(tempAssetsInfoShow).toNumber();
      var tempVal2 = JSON.parse(JSON.stringify(tempVal)) * 100;

      if (tempVal2 > 100) {
        tempVal2 = 100;
      }

      this.buySliderValue = Number(tempVal2.toFixed(0));
      var tempValV3 = "0";

      if (this.buyAmount == "0") {
        tempValV3 = "0";
      } else if (this.buyAmount != "" && this.marketInfoShow.last) {
        var bigBuyNum = new _bignumber.default(this.buyAmount);
        var bigMarketInfoShow = new _bignumber.default(this.marketInfoShow.last);
        tempValV3 = bigBuyNum.div(bigMarketInfoShow).toNumber().toFixed(this.number_precision);
      } else {
        tempValV3 = "0";
      }

      this.buyTransactionAmount = tempValV3;
      setTimeout(function () {
        _this8.inputControl = false;
      }, 1000);
    },
    // 限价买入量变化
    onBuyNumChange: function onBuyNumChange(val) {
      var _this9 = this;

      //买入金额6 buyTransactionAmountSelf
      // 买入价2  buyPrice
      if (!this.buyPrice || !this.buyNum) {
        this.buySliderValue = 0;
        this.buyTransactionAmountSelf = "";
        return;
      }

      this.inputControl = true;
      var tempInput = new _bignumber.default(this.buyNum);
      var tempPrice = new _bignumber.default(this.buyPrice);
      var tempAssetsInfoShow = new _bignumber.default(this.assetsInfoShow);
      var tempR = tempInput.times(tempPrice);
      var tempAmout = tempR.toNumber();
      this.buyTransactionAmountSelf = this.ceilNumber(tempAmout, this.price_precision);
      var tempValue = tempR.toNumber() / tempAssetsInfoShow * 100;
      this.buySliderValue = Number(tempValue.toFixed(2));
      setTimeout(function () {
        _this9.inputControl = false;
      }, 1000);
    },
    // 限价卖出量变化
    onSellNumChange: function onSellNumChange(val) {
      var _this10 = this;

      if (!val) {
        this.inputControl = true;
        this.sellSliderValue = 0;
        this.sellTransactionAmount = "";
        this.sellTransactionAmountSelf = "";
        return;
      } //卖出金额10 sellTransactionAmount


      this.marketPrice = JSON.parse(JSON.stringify(this.marketInfoShow.last));
      var tempMarketPrice = new _bignumber.default(this.marketPrice);
      var tempInput = new _bignumber.default(val);

      if (this.userInfo) {
        this.inputControl = true;
        var tempAssetsInfoShow = new _bignumber.default(this.assetsInfoShowSell);
        var tempValue = tempInput.div(tempAssetsInfoShow);
        this.sellSliderValue = Number((tempValue.toNumber() * 100).toFixed(0));
      }

      if (this.currChainValue == "1") {
        var tempValue2 = tempInput.times(tempMarketPrice).toNumber();

        if (tempValue2.toString().indexOf(".") > 0) {
          this.sellTransactionAmount = tempValue2.toString().substring(0, tempValue2.toString().indexOf(".") + this.price_precision + 1);
        } else {
          this.sellTransactionAmount = tempValue2;
        }
      } else {
        if (this.sellPrice) {
          var tempSellPrice = new _bignumber.default(this.sellPrice);
          var tempValue3 = tempInput.times(tempSellPrice);

          if (tempValue3.toString().indexOf(".") > 0) {
            this.sellTransactionAmountSelf = tempValue3.toFixed(this.price_precision).substring(0, tempValue3.toFixed(this.price_precision).indexOf(".") + this.price_precision + 1);
          } else {
            this.sellTransactionAmountSelf = tempValue3.toFixed(this.price_precision);
          }
        }
      }

      setTimeout(function () {
        _this10.inputControl = false;
      }, 1000);
    },
    onSellPriceChange: function onSellPriceChange() {
      // 卖出价格 sellPrice   卖出数量 sellNum  卖出金额 sellTransactionAmountSelf
      if (this.sellPrice && this.sellNum) {
        var tempValue = this.sellPrice * this.sellNum;

        if (tempValue.toString().indexOf(".") > 0) {
          this.sellTransactionAmountSelf = tempValue.toString().substring(0, tempValue.toString().indexOf(".") + this.price_precision + 1);
        } else {
          this.sellTransactionAmountSelf = tempValue;
        }
      }
    },
    // 市价买入数量变化
    onBuyTotalChange: function onBuyTotalChange(val) {
      var _this11 = this;

      this.marketPrice = JSON.parse(JSON.stringify(this.marketInfoShow.last));
      this.inputControl = true; // 买入 预计开仓数量

      var tempValV2 = "0";

      if (this.buyTransactionAmount == "0" || this.buyTransactionAmount == "") {
        tempValV2 = "0";
        this.buyAmount = "";
      } else if (this.buyTransactionAmount != "" && this.marketInfoShow.last) {
        var bigBuyAmount = new _bignumber.default(this.buyTransactionAmount);
        var bigMarketInfoShow = new _bignumber.default(JSON.parse(JSON.stringify(this.marketPrice)));
        tempValV2 = bigBuyAmount.times(bigMarketInfoShow).toNumber();
        this.buyAmount = tempValV2.toFixed(this.price_precision);
      } else {
        tempValV2 = "0";
        this.buyAmount = "";
      }

      var tempAssetsInfoShow = new _bignumber.default(this.assetsInfoShow);
      var tempBuyAmount = new _bignumber.default(this.buyAmount);
      var tempVal = tempBuyAmount.div(tempAssetsInfoShow).toNumber();
      var tempVal2 = JSON.parse(JSON.stringify(tempVal)) * 100;

      if (tempVal2 > 100) {
        tempVal2 = 100;
      }

      this.buySliderValue = Number(tempVal2.toFixed(2)); // 买入滑块

      setTimeout(function () {
        _this11.inputControl = false;
      }, 1000);
    },
    onBuyNumChangeSelf: function onBuyNumChangeSelf() {
      var _this12 = this;

      // 限价买入价格2 buyPrice
      //限价买入金额6 buyTransactionAmountSelf
      var tempValV3 = "0";
      this.inputControl = true;
      var bigBuyNum = new _bignumber.default(this.buyTransactionAmountSelf);

      if (this.buyTransactionAmountSelf == "0") {
        tempValV3 = "0";
      } else if (this.buyTransactionAmountSelf != "" && this.buyPrice) {
        var bigBuyPrice = new _bignumber.default(this.buyPrice);
        var tempValV4 = bigBuyNum.div(bigBuyPrice).toNumber();
        tempValV3 = this.ceilNumber(tempValV4, this.number_precision);
      } else {
        tempValV3 = "0";
      }

      var tempAssetsInfoShow = new _bignumber.default(this.assetsInfoShow);
      var tempVal = bigBuyNum.div(tempAssetsInfoShow).toNumber();
      var tempVal2 = JSON.parse(JSON.stringify(tempVal)) * 100;

      if (tempVal2 > 100) {
        tempVal2 = 100;
      }

      this.buySliderValue = Number(tempVal2.toFixed(2));
      this.buyNum = tempValV3; // 买入滑块

      setTimeout(function () {
        _this12.inputControl = false;
      }, 1000);
    },
    onSellTransactionAmountChange: function onSellTransactionAmountChange(val) {
      var _this13 = this;

      // 卖出数量9 sellNum
      //卖出金额10 sellTransactionAmount
      //可用数量 assetsInfoShowSell
      var tempVal = "0";
      this.inputControl = true;

      if (this.sellTransactionAmount == "" || this.sellTransactionAmount == 0) {
        tempVal = "0";
      } else {
        var tempPrice = JSON.parse(JSON.stringify(this.marketInfoShow.last));
        var bigMarketInfoShow = new _bignumber.default(tempPrice);
        var tempSellTransactionAmount = new _bignumber.default(this.sellTransactionAmount);
        var tempAssetsInfoShow = new _bignumber.default(this.assetsInfoShowSell);
        tempVal = tempSellTransactionAmount.div(bigMarketInfoShow).toNumber();
        var tempVal2 = tempSellTransactionAmount.div(bigMarketInfoShow).div(tempAssetsInfoShow);
        this.sellNum = tempVal.toString().substring(0, tempVal.toString().indexOf(".") + this.number_precision + 1);
        this.sellSliderValue = Number((tempVal2 * 100).toFixed(2));
      }

      setTimeout(function () {
        _this13.inputControl = false;
      }, 1000);
    },
    onSellAmoutSelfChange: function onSellAmoutSelfChange(val) {
      var tempVal = "0";
      this.inputControl = true;

      if (this.sellTransactionAmountSelf == "" || this.sellTransactionAmountSelf == 0 || this.sellPrice == "" || this.sellPrice == 0) {
        tempVal = "0";
      } else {
        var tempPrice = JSON.parse(JSON.stringify(this.sellPrice));
        var bigMarketInfoShow = new _bignumber.default(tempPrice);
        var tempSellTransactionAmount = new _bignumber.default(this.sellTransactionAmountSelf);
        var tempAssetsInfoShow = new _bignumber.default(this.assetsInfoShowSell);
        tempVal = tempSellTransactionAmount.div(bigMarketInfoShow).toNumber();
        var tempVal2 = tempSellTransactionAmount.div(bigMarketInfoShow).div(tempAssetsInfoShow);
        this.sellNum = tempVal.toString().substring(0, tempVal.toString().indexOf(".") + this.number_precision + 1);
        this.sellSliderValue = Number((tempVal2 * 100).toFixed(2));
      }
    },
    formatTooltip: function formatTooltip(val) {
      return val + "%";
    },
    onTrade: function onTrade(type) {
      var _this14 = this;

      // 1买入 2卖出
      if (type == 1) {
        if (this.currChainValue == "1") {
          if (this.buyAmount == "" || Number(this.buyAmount == 0)) {
            (0, _message.showMessage)({
              message: this.translateTitle("请输入交易额"),
              type: "error"
            });
            return;
          }

          if (Number(this.buyAmount) > Number(this.assetsInfoShow)) {
            (0, _message.showMessage)({
              message: this.translateTitle("可用余额不足"),
              type: "error"
            });
            return;
          }

          this.buyBtnLoading = true;
          var params = {
            symbol_id: this.swap_symbol_id,
            side: "buy",
            trust_type: "1",
            // 1-普通|2-立即取消
            assets_type: "1",
            // 1-币币|2-杠杆|3-杠杆爆仓
            type: "2",
            //  1-限价单|2-市价单
            total: this.buyAmount // 购买数量

          };
          (0, _index.apiTrustStore)(params).then(function (res) {
            if (res.status == 200) {
              (0, _message.showMessage)({
                message: _this14.translateTitle("下单成功"),
                type: "success"
              });
              _this14.buyBtnLoading = false;

              _this14.reSetData();

              _this14.getAssets();

              _this14.$emit("on-trade-success", "2");
            } else {
              _this14.buyBtnLoading = false;
            }
          });
        } else if (this.currChainValue == "2") {
          if (this.buyPrice == "" || Number(this.buyPrice == 0)) {
            (0, _message.showMessage)({
              message: this.translateTitle("请输入买入价格"),
              type: "error"
            });
            return;
          }

          if (this.buyNum == "" || Number(this.buyNum == 0)) {
            (0, _message.showMessage)({
              message: this.translateTitle("请输入买入量"),
              type: "error"
            });
            return;
          }

          if (Number(this.buyTransactionAmountSelf) > Number(this.assetsInfoShow)) {
            (0, _message.showMessage)({
              message: this.translateTitle("可用余额不足"),
              type: "error"
            });
            return;
          }

          this.buyBtnLoading = true;
          var _params = {
            symbol_id: this.swap_symbol_id,
            side: "buy",
            trust_type: "1",
            // 1-普通|2-立即取消
            assets_type: "1",
            // 1-币币|2-杠杆|3-杠杆爆仓
            type: "1",
            //  1-限价单|2-市价单
            num: this.buyNum,
            // 购买数量
            price: this.buyPrice
          };
          (0, _index.apiTrustStore)(_params).then(function (res) {
            if (res.status == 200) {
              (0, _message.showMessage)({
                message: _this14.translateTitle("下单成功"),
                type: "success"
              });
              _this14.buyBtnLoading = false;

              _this14.getAssets();

              _this14.reSetData();

              _this14.$emit("on-trade-success", "1");
            } else {
              _this14.buyBtnLoading = false;
            }
          });
        }
      } else {
        // 2 卖出
        if (this.currChainValue == "1") {
          if (this.sellNum == "" || Number(this.sellNum == 0)) {
            (0, _message.showMessage)({
              message: this.translateTitle("请输入卖出量"),
              type: "error"
            });
            return;
          }

          if (Number(this.sellNum) > Number(this.assetsInfoShowSell)) {
            (0, _message.showMessage)({
              message: this.translateTitle("可用余额不足"),
              type: "error"
            });
            return;
          }

          this.sellBtnLoading = true;
          var _params2 = {
            symbol_id: this.swap_symbol_id,
            side: "sell",
            trust_type: "1",
            // 1-普通|2-立即取消
            assets_type: "1",
            // 1-币币|2-杠杆|3-杠杆爆仓
            type: "2",
            //  1-限价单|2-市价单
            num: this.sellNum // 购买数量

          };
          (0, _index.apiTrustStore)(_params2).then(function (res) {
            if (res.status == 200) {
              (0, _message.showMessage)({
                message: _this14.translateTitle("下单成功"),
                type: "success"
              });

              _this14.reSetData();

              _this14.getAssets();

              _this14.$emit("on-trade-success", "2");
            } else {
              _this14.sellBtnLoading = false;
            }

            _this14.sellBtnLoading = false;
          });
        } else if (this.currChainValue == "2") {
          if (this.sellPrice == "" || Number(this.sellPrice == 0)) {
            (0, _message.showMessage)({
              message: this.translateTitle("请输入卖出价"),
              type: "error"
            });
            return;
          }

          if (this.sellNum == "" || Number(this.sellNum == 0)) {
            (0, _message.showMessage)({
              message: this.translateTitle("请输入卖出量"),
              type: "error"
            });
            return;
          }

          if (Number(this.sellNum) > Number(this.assetsInfoShowSell)) {
            (0, _message.showMessage)({
              message: this.translateTitle("可用余额不足"),
              type: "error"
            });
            return;
          }

          this.sellBtnLoading = true;
          var _params3 = {
            symbol_id: this.swap_symbol_id,
            side: "sell",
            trust_type: "1",
            // 1-普通|2-立即取消
            assets_type: "1",
            // 1-币币|2-杠杆|3-杠杆爆仓
            type: "1",
            //  1-限价单|2-市价单
            num: this.sellNum,
            // 购买数量
            price: this.sellPrice
          };
          (0, _index.apiTrustStore)(_params3).then(function (res) {
            if (res.status == 200) {
              (0, _message.showMessage)({
                message: _this14.translateTitle("下单成功"),
                type: "success"
              });
              _this14.sellBtnLoading = false;

              _this14.reSetData();

              _this14.getAssets();

              _this14.$emit("on-trade-success", "1");
            } else {
              _this14.sellBtnLoading = false;
            }

            _this14.sellBtnLoading = false;
          });
        }
      }
    },
    goLogin: function goLogin(type) {
      if (type == 1) {
        this.$router.push({
          path: this.routeSplicing(this.language, "login"),
          query: {
            redirect: this.$route.fullPath
          }
        });
      } else {
        this.$router.push(this.routeSplicing(this.language, "register"));
      }
    },
    onChainChange: function onChainChange(value) {
      var _this15 = this;

      this.inputControl = true;
      this.sellSliderValue = 0;
      this.buySliderValue = 0;
      this.currChainValue = value;
      this.buyNum = "";
      this.buyPrice = "";
      this.buyAmount = "";
      this.sellPrice = "";
      this.sellNum = "";
      this.sellTransactionAmountSelf = "";
      this.sellTransactionAmount = "";
      this.buyTransactionAmount = "";
      this.buyTransactionAmountSelf = "";
      setTimeout(function () {
        _this15.inputControl = false;
      }, 300);
    },
    reSetData: function reSetData() {
      var _this16 = this;

      this.inputControl = true;
      this.sellSliderValue = 0;
      this.buySliderValue = 0;
      this.buyNum = "";
      this.buyPrice = "";
      this.buyAmount = "";
      this.sellPrice = "";
      this.sellNum = "";
      this.sellTransactionAmountSelf = "";
      this.sellTransactionAmount = "";
      this.buyTransactionAmount = "";
      this.buyTransactionAmountSelf = "";
      setTimeout(function () {
        _this16.inputControl = false;
      }, 300);
    },
    getStaticTableInfo: function getStaticTableInfo(sv_id) {
      var _this17 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$apiGetStaticTa, status, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(sv_id);

              case 2:
                _yield$apiGetStaticTa = _context3.sent;
                status = _yield$apiGetStaticTa.status;
                data = _yield$apiGetStaticTa.data;

                if (status == 200) {
                  _this17.coinInfoMap = JSON.parse(JSON.stringify(data));

                  if (_this17.swap_symbol_id) {
                    _this17.number_precision = _this17.coinInfoMap[_this17.swap_symbol_id].number_precision;
                    _this17.price_precision = _this17.coinInfoMap[_this17.swap_symbol_id].price_precision;
                  } // this.coinInfoList = JSON.parse(JSON.stringify(data));
                  // for (const key in this.coinInfoList) {
                  //   if (this.coinInfoList[key].swap_symbol_id == this.swap_symbol_id) {
                  //     this.from_item_id = this.coinInfoList[key].from_item_id;
                  //     this.to_item_id = this.coinInfoList[key].to_item_id;
                  //   }
                  // }

                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};
exports.default = _default2;